import { Input, Typography } from "antd";

const KSearchBar = ({
  onChange,
  title,
  suffix,
  onClear,
  placeholder,
  style,
}) => {
  return (
    <>
      <Typography className="fw-400 fz-14 mb-3" style={{ color: "#04326B" }}>
        {title}
      </Typography>
      <Input
        size="small"
        suffix={suffix}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e);
          if (!e.target.value && onClear) {
            onClear();
          }
        }}
        styles={{
          input: {
            padding: "0 8px",
            fontSize: "12px",
            height: "24px",
            lineHeight: "24px",
          },
        }}
        style={{
          border: "1px solid #D0D5DD",
          height: "24px",
        }}
        allowClear
      />
    </>
  );
};

export default KSearchBar;
